<template>
    <svg id="Lager_1" data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 11.6999998 11.6999998">
        <g>
            <path class="cls-1" d="M7.8071669,9.7184647V1.9815351c0-1.0133554.8214869-1.8348423,1.8348423-1.8348423h.0000037"/>
            <path class="cls-1" d="M2.4249576,9.7184647V1.9815351C2.4249576.9681797,3.2464444.1466928,4.2597998.1466928h.0000037"/>
            <path class="cls-1" d="M5.9723247.1466928"/>
            <path class="cls-1" d="M5.9723247,11.553307h-.0000037c-1.0133554,0-1.8348423-.8214869-1.8348423-1.8348423H.2231447c0,1.0133554.8214869,1.8348423,1.8348423,1.8348423h.0000037"/>
            <path class="cls-1" d="M2.0579869,11.553307h3.9143378c1.0133554,0,1.8348423-.8214869,1.8348423-1.8348423V1.9815351"/>
            <path class="cls-1" d="M4.2597998.1466928h5.382213c1.0133554,0,1.8348423.8214869,1.8348423,1.8348423v1.3659413h-3.6696882"/>
            <line class="cls-1" x1="3.3423805" y1="3.9183168" x2="6.767422" y2="3.9183168"/>
        </g>
        <line class="cls-1" x1="3.3423805" y1="6.2016784" x2="6.767422" y2="6.2016784"/>
    </svg>
</template>
<style>
.cls-1 {
    fill: none;
    stroke: #000;
    stroke-linejoin: round;
    stroke-width: 0.25px;
}
</style>
